const NotFound: React.FC = () => {
  return (
    <div className='centered'>
      <p>Pagina no encontrada!</p>
    </div>
  );
};

export default NotFound;
